import React from "react";
import { useTranslation } from "react-i18next";
import HelmetSeo from "../../components/Site/Reusable/HelmetSeo";
import Hero from "../../components/Site/Reusable/Hero";
import SpacingItem from "../../components/Site/Reusable/SpacingItem";
import CyberInfo from "../../components/Site/Reusable/CyberInfo";
import InfoBlockAi from "../../components/Site/Reusable/InfoBlockAi";
import TitleDescription from "../../components/Site/Reusable/TitleDescription";

import "../../assets/cert.scss";

const Cert = () => {
  const { t } = useTranslation();

  return (
    <div className="cert-page">
      <HelmetSeo
        title={`${t("cert.title")} | Oktacron`}
        description={t("cert.intro")}
      />
      <Hero title={t("cert.title")} img="services-hero.png" />
      <SpacingItem />
      <CyberInfo text={t("cert.intro")} />
      <InfoBlockAi text={t("cert.definition")} />
      <section className="ai-section-9" id="cert-meaning">
        <div className="ai-section-9-content">
          <div className="container-fluid">
            <div className="row">
              <h2>{t("cert.meaningTitle")}</h2>
              <div className="ai-section-9-items-list">
                {t("cert.benefits", { returnObjects: true }).map((benefit) => (
                  <div className="ai-section-9-item" key={benefit}>
                    <h3>{benefit}</h3>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <TitleDescription
        id="cert-status"
        title={t("cert.statusTitle")}
        description={t("cert.status")}
      >
        <p>{t("cert.registry")}</p>
        <p>
          <a
            href="https://www.cert.rs/rs/evidencija-certova.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.cert.rs/rs/evidencija-certova.html
          </a>
        </p>
      </TitleDescription>
      <TitleDescription
        id="cert-contact"
        title={t("cert.contactTitle")}
        description={t("cert.contact")}
      >
        <p>
          {t("cert.email")} <a href="mailto:cert@oktacron.rs">cert@oktacron.rs</a>
        </p>
        <p>
          {t("cert.phone")} <a href="tel:+381607048644">+381 60 704 86 44</a>
        </p>
      </TitleDescription>
      <TitleDescription
        id="cert-soc"
        title={t("cert.socTitle")}
      />
      <InfoBlockAi text={t("cert.soc")} />
    </div>
  );
};

export default Cert;
